/* ============================================================
   SKULLBORNED — LIGHTBOX LIFESTYLE BLINDADO v1.0 (22 Jul 2026)
   ============================================================
   PROBLEMA:
   La galería lifestyle (slb-lf, custom liquid v1.4 en la plantilla
   de producto) engancha sus clics UNA sola vez al cargar la página.
   Cuando el tema re-renderiza secciones (cambio de variante, morphs
   de Horizon, peculiaridades del navegador integrado de Facebook/
   Instagram), esos listeners se pierden y los taps sobre las fotos
   mueren en silencio — sin error en consola. Patrón detectado en
   grabaciones de Clarity (ráfagas de taps sin respuesta).

   SOLUCIÓN:
   Delegación de eventos a nivel documento en FASE DE CAPTURA.
   - Sobrevive a cualquier reemplazo del DOM (no depende de nodos).
   - stopPropagation() en captura impide que el script inline de la
     sección duplique acciones (no hay doble-avance ni doble-open).
   - Recalcula el masonry (gridRowEnd) también tras re-renders.

   REVERSIBLE:
   Borrar este archivo y su <script> en layout/theme.liquid
   (bloque "LIGHTBOX LIFESTYLE BLINDADO").
   ============================================================ */
(function () {
  'use strict';
  if (window.__slbLfFix) return;
  window.__slbLfFix = true;

  function lb()      { return document.getElementById('slbLfLb'); }
  function lbImg()   { return document.getElementById('slbLfLbImg'); }
  function lbCount() { return document.getElementById('slbLfCount'); }
  function items()   { return Array.prototype.slice.call(document.querySelectorAll('.slb-lf__item')); }

  var cur = 0;

  function render() {
    var list = items();
    var box = lb();
    if (!box || !list.length) return;
    if (cur < 0) cur = list.length - 1;
    if (cur >= list.length) cur = 0;
    var full = list[cur].getAttribute('data-full');
    var img = lbImg();
    if (img && full) img.src = full;
    var c = lbCount();
    if (c) c.textContent = (cur + 1) + ' / ' + list.length;
    var multi = list.length > 1;
    var prev = document.getElementById('slbLfPrev');
    var next = document.getElementById('slbLfNext');
    if (prev) prev.style.display = multi ? '' : 'none';
    if (next) next.style.display = multi ? '' : 'none';
    if (c) c.style.display = multi ? '' : 'none';
  }

  function open(i) {
    var box = lb();
    if (!box) return;
    cur = i;
    render();
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var box = lb();
    if (!box) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function go(d) { cur += d; render(); }

  /* ---- Clics: delegados en captura (toman el control del inline) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var item = t.closest('.slb-lf__item');
    if (item) {
      e.preventDefault();
      e.stopPropagation();
      open(items().indexOf(item));
      return;
    }
    if (t.closest('#slbLfClose')) { e.stopPropagation(); close(); return; }
    if (t.closest('#slbLfPrev'))  { e.stopPropagation(); go(-1); return; }
    if (t.closest('#slbLfNext'))  { e.stopPropagation(); go(1);  return; }
    var box = lb();
    if (box && e.target === box) { e.stopPropagation(); close(); }
  }, true);

  /* ---- Teclado ---- */
  document.addEventListener('keydown', function (e) {
    var box = lb();
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === 'ArrowLeft') go(-1);
  });

  /* ---- Deslizar en móvil (delegado, en captura) ---- */
  var x0 = null;
  document.addEventListener('touchstart', function (e) {
    var box = lb();
    if (!box || !box.classList.contains('is-open')) return;
    x0 = e.touches[0].clientX;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    var box = lb();
    if (!box || !box.classList.contains('is-open') || x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
    x0 = null;
  }, { passive: true, capture: true });

  /* ---- Masonry: recalcular alturas también tras re-renders ---- */
  function computeSpans() {
    var grids = document.querySelectorAll('.slb-lf__grid');
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 10;
      var its = grid.querySelectorAll('.slb-lf__item');
      for (var i = 0; i < its.length; i++) {
        var img = its[i].querySelector('img');
        if (!img) continue;
        var colW = img.getBoundingClientRect().width;
        if (!colW) continue;
        var w = parseFloat(img.getAttribute('width'));
        var h = parseFloat(img.getAttribute('height'));
        var imgH = (w && h) ? colW * (h / w) : img.getBoundingClientRect().height;
        if (imgH) its[i].style.gridRowEnd = 'span ' + Math.ceil(imgH + gap);
      }
    }
  }

  if (document.readyState !== 'loading') computeSpans();
  else document.addEventListener('DOMContentLoaded', computeSpans);
  window.addEventListener('load', computeSpans);
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(computeSpans, 120); });
  document.addEventListener('load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('slb-lf__img')) computeSpans();
  }, true);
  document.addEventListener('shopify:section:load', function () { setTimeout(computeSpans, 50); });
  document.addEventListener('variant:update', function () { setTimeout(computeSpans, 50); });
})();
